import { Component, Input, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import { DateAdapter } from "@angular/material/core";
import { TooltipPosition } from "@angular/material/tooltip";
import * as Jquery from "../../assets/jquery-3.5.1.min";
import { User2AF } from "../_models";
import { AccountService, AlertService } from "src/app/_services";
import { Location } from "@angular/common";
import { Router } from "@angular/router";

@Component({
  selector: "app-menu",
  templateUrl: "./menu.component.html",
  styleUrls: ["./menu.component.css"],
})
export class MenuComponent implements OnInit {
  @Input() data: User2AF;

  notifications: string[];
  totalNotifications: any;
  imageUrl: any;

  positionOptions: TooltipPosition[] = [
    "after",
    "before",
    "above",
    "below",
    "left",
    "right",
  ];
  position = new FormControl(this.positionOptions[0]);

  constructor(
    private dateAdapter: DateAdapter<Date>,
    private accountService: AccountService,
    private location: Location,
    private router: Router
  ) {
    this.dateAdapter.setLocale("pt-BR");
  }

  ngOnInit(): void {
    Jquery("#menu-toggle").click(function (e) {
      e.preventDefault();
      Jquery("#wrapper").toggleClass("toggled");

      function hasClass(element, cls) {
        return (" " + element.className + " ").indexOf(" " + cls + " ") > -1;
      }

      var el = document.getElementById("wrapper");
      if (screen.width >= 768 && hasClass(el, "toggled") == true) {
        $("#page-content-wrapper").removeClass("pcw-16");
        $("#page-content-wrapper").addClass("pcw-0");
      } else if (screen.width >= 768 && hasClass(el, "toggled") == false) {
        $("#page-content-wrapper").removeClass("pcw-0");
        $("#page-content-wrapper").addClass("pcw-16");
      }

      if (screen.width < 768 && hasClass(el, "toggled") == false) {
        $("#page-content-wrapper").removeClass("pcw-16");
        $("#page-content-wrapper").addClass("pcw-0");
      } else if (screen.width < 768 && hasClass(el, "toggled") == true) {
        $("#page-content-wrapper").removeClass("pcw-0");
        $("#page-content-wrapper").addClass("pcw-16");
      }
    });

     this.observeColaboratorElement();
                                this.observeHiddenInputs();
  }

  logoVivo(el) {
    var display = document.getElementById(el).style.display;
    if (display == "none") document.getElementById(el).style.display = "block";
    else document.getElementById(el).style.display = "none";
  }

  isHomePage(): boolean {
    return this.router.url === '/';
  }

  goBack(): void {
    this.location.back();
  }

  // logout
  logout() {
    this.accountService.logout();
  }

   observeColaboratorElement(): void {
     const observer = new MutationObserver(() => {

       const colaboratorElement = document.getElementById('colaborator-eleva');
       if (colaboratorElement && this.data && this.data.user) {
         colaboratorElement.textContent = this.data.user.firstName + ' ' + this.data.user.lastName;

         const email = (this.data.user.email || '').toLowerCase();
                  const isAllowed =
                    email === 'sidney@media4all.com.br' ||
                    email === 'felipe@media4all.com.br' ||
                    email === 'jorge@media4all.com.br' ||
                    email === 'victor@media4all.com.br' ||
                    email === 'juliano.teixeira@telefonica.com' ||
                    email === 'thalles.borges@telefonica.com' ||
                    email === 'isabela.bosco@telefonica.com' ||

                    email === 'josimar.mmatias@telefonica.com' ||
                    email === 'rodrigo.ferme@telefonica.com' ||
                    email === 'daniela.caldeira@telefonica.com' ||
                    email === 'jessica.marinaro@telefonica.com' ||
                    email === 'tiago.andrade@telefonica.com' ||
                    email === 'fabio.fbarbosa@telefonica.com' ||

                    email === 'danilo.silveira@telefonica.com';

         // Tenta aplicar imediatamente; se o elemento ainda não existe, observa o DOM até existir
         const applyVisibility = (): boolean => {
           const bot1= document.getElementById('chat-button') as HTMLElement;
           if (!bot1) return false;
           // quando permitido, limpa o style pra usar o CSS padrão; senão, esconde
           bot1.style.display = isAllowed ? 'block' : 'none';

           const bot2= document.getElementById('chat-bubble') as HTMLElement;
                      if (!bot2) return false;
                      // quando permitido, limpa o style pra usar o CSS padrão; senão, esconde
                      bot2.style.display = isAllowed ? 'block' : 'none';
           return true;
         };

         if (!applyVisibility()) {
           const botObserver = new MutationObserver(() => {
             if (applyVisibility()) botObserver.disconnect();
           });
           botObserver.observe(document.body, { childList: true, subtree: true });
         }

         observer.disconnect();
       }
     });

     observer.observe(document.body, { childList: true, subtree: true });
   }

    // Função para iniciar o MutationObserver e observar quando os inputs hidden são adicionados ao DOM
      observeHiddenInputs(): void {
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            // Procura pelos elementos hidden no DOM
            const hiddenUrlElement = document.getElementById('hiddenUrl') as HTMLInputElement;
            const hiddenTokenElement = document.getElementById('hiddenToken') as HTMLInputElement;

           var userToken = this.accountService.userValue.token;

            // Se ambos os inputs hidden existirem, define os valores e desconecta o observer
            if (hiddenUrlElement && hiddenTokenElement) {
              hiddenUrlElement.value = 'https://app.elevasign.com.br/gasmeter/chatbot';
              hiddenTokenElement.value = userToken;
              observer.disconnect();
            }
          });
        });

        // Observa o body para mudanças, incluindo adição de elementos
        observer.observe(document.body, { childList: true, subtree: true });
      }




}
